import styled from "@emotion/styled";

interface ChipCloseButtonProps {
    isActive: boolean;
    isReadonly: boolean;
}

export const ChipRemoveButton = styled("div")<ChipCloseButtonProps>`
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
    padding: 2px 0;
    color: inherit;

    // This doesn't do anything in Chrome because it's dealt with in the user-agent-stylesheet
    // But in every other browser it's necessary to vertically center the button.
    display: inline-flex;
    align-items: center;

    cursor: ${({ isReadonly }) => (isReadonly ? "auto" : "pointer")};
`;
